interface ITabset {
  [key: string]: ITab;
}

export interface ITab {
  title: string;
  key: string;
  link: string | string[];
  IconComponent?: any;
  permissionOpen: boolean;
  active: boolean;
  showSummary: boolean;
  columnPickerPath?: string;
  gridPath?: string;
  count: number;
  subTabs?: any;
}

export const TABSET: ITabset = {
  'seed-data': {
    title: 'Seed Data',
    key: 'seed-data',
    link: '/pages/settings/asset-management/seed-data/key-domains',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: '',
    gridPath: 'seed-data',
    count: 0,
    subTabs: {
      'key-domains': {
        title: 'Key Domains',
        key: 'key-domains',
        link: '/pages/settings/asset-management/seed-data/key-domains',
        gridPath: 'key-domains',
        count: 0
      },
      'related-names': {
        title: 'Related Names',
        key: 'related-names',
        link: '/pages/settings/asset-management/seed-data/related-names',
        gridPath: 'related-names',
        count: 0
      }
    }
  }
};
